var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getAmountWithVat } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import groupBy from "lodash/groupBy";
export var getGroupId = function (invoiceItem) {
    return "".concat(invoiceItem.resourceType, "-").concat(invoiceItem.price, "-").concat(invoiceItem.isPrepaid);
};
export var getInvoiceItemsDataSource = function (params) {
    var unsortedInvoiceItems = params.invoiceItems, selectedKey = params.selectedKey, expandAllGroups = params.expandAllGroups;
    var invoiceItems = unsortedInvoiceItems
        ? unsortedInvoiceItems.sort(function (_a, _b) {
            var a = _a.propertyId;
            var b = _b.propertyId;
            return !a || !b ? 0 : a - b;
        })
        : undefined;
    var result = [];
    var groupedItems = groupBy(invoiceItems, getGroupId);
    Object.values(groupedItems).forEach(function (groupedInvoiceItems) {
        var isGrouped = groupedInvoiceItems.length > 1;
        var firstItem = groupedInvoiceItems[0];
        var isActiveGroup = expandAllGroups || getGroupId(firstItem) === selectedKey;
        // Add header for active group
        if (isGrouped) {
            var totalPrice = groupedInvoiceItems.reduce(function (temp, x) { return temp + (x.price || 0); }, 0);
            var header = {
                id: "".concat(firstItem.resourceType, "-header"),
                resourceType: firstItem.resourceType,
                isPrepaid: firstItem.isPrepaid,
                totalAmount: groupedInvoiceItems.reduce(function (temp, x) { return temp + (x.amount || 1); }, 0),
                price: firstItem.price,
                totalPrice: totalPrice,
                totalPriceIncludingVat: getAmountWithVat(totalPrice, firstItem.VATPercentage),
                VATPercentage: firstItem.VATPercentage,
            };
            result.push({ header: header });
        }
        if (isGrouped && isActiveGroup) {
            result.push.apply(result, groupedInvoiceItems.map(function (x) { return ({ item: x }); }));
        }
        if (!isGrouped) {
            result.push.apply(result, groupedInvoiceItems.map(function (x) { return ({ item: x }); }));
        }
    });
    return result;
};
/** The resource type the billing worker gives every SMS line. */
var SMS_NOTIFICATION_RESOURCE_TYPE = "sms_notification";
/**
 * Which part of an SMS each SMS line is, by line id (DEV-3572). A visit
 * reminder sent in several parts is billed one line per part, all with the
 * same activity; those lines read "(part 1/3)" and so on. A line that is the
 * only one for its activity, which is every group communication SMS and every
 * one-part reminder, gets no entry, so no label.
 */
export var getSmsPartsByInvoiceItemId = function (invoiceItems) {
    if (invoiceItems === void 0) { invoiceItems = []; }
    var smsItemsByActivity = groupBy(invoiceItems.filter(function (item) {
        return "".concat(item.resourceType) === SMS_NOTIFICATION_RESOURCE_TYPE &&
            !!item.activityId;
    }), function (item) { return item.activityId; });
    var result = {};
    Object.values(smsItemsByActivity).forEach(function (items) {
        if (items.length < 2) {
            return;
        }
        __spreadArray([], items, true).sort(function (a, b) { return a.id - b.id; })
            .forEach(function (item, index) {
            result[item.id] = { index: index + 1, total: items.length };
        });
    });
    return result;
};
